import App from './App.vue';
// 🎯 MIGRATION FABRIC 6.X COMPLÈTE: Plus besoin de window.fabric
// Tous les fichiers utilisent maintenant des imports directs

const app = createApp(App);
const head = createHead();
registerPlugins(app);

app.use(i18n);
app.use(head);
app.mount('#app');
